import { useEffect, useState } from "react";
import { gql, useLazyQuery, useMutation } from "@apollo/client";
import {
  Collapse,
  Skeleton,
  Alert,
  Space,
  Row,
  Col,
  Button,
  Select,
  Form,
  Input,
  TimePicker,
  Modal,
} from "antd";
import moment from "moment-jalaali";
import DatePicker from "@general/datePicker";
import useReservedHours from "@general/useReservedHours";

moment.loadPersian({ usePersianDigits: false });

function ConsultationsTableDetails({ id, onDataUpdate, onCloseDrawer }) {
  const GETCONSULTATION = gql`
    query ($id: ID!) {
      getPurchase(id: $id) {
        createdAt
        amount
        description
        product {
          name
        }
        reserve {
          startAt
          endAt
          description
          product {
            name
          }
        }
        user {
          id
          name
          mobile
        }
      }
    }
  `;

  const GETMEETINGROOMSLIST = gql`
    query ($paginateInput: PaginateInput!, $searchInput: ProductSearchInput!) {
      getProducts(paginateInput: $paginateInput, searchInput: $searchInput) {
        name
        id
        reservedPurchases {
          startAt
          endAt
        }
      }
    }
  `;

  const SETMEETINGTIME = gql`
    mutation CreateConsultationPurchase(
      $createConsultationPurchaseInput: CreateConsultationPurchaseInput!
    ) {
      createConsultationPurchase(
        createConsultationPurchaseInput: $createConsultationPurchaseInput
      ) {
        id
      }
    }
  `;
  const [initialData, setInitialData] = useState({});
  const [form] = Form.useForm();
  const { TextArea } = Input;
  const [formData, setFromData] = useState(null);
  const [refetch, setRefetch] = useState(0);
  const [meetingRooms, setMeetingRooms] = useState(null);
  const [selectedMeetingRoom, setSelectedMeetingRoom] = useState(null);
  const [disabledStartHours, setDisabledStartHours] = useState([]);
  const [selectedMeetingDate, setSelectedMeetingDate] = useState(null);
  const reservedHours = useReservedHours(
    selectedMeetingRoom,
    selectedMeetingDate
  );
  const [startTime, setStartTime] = useState(null);

  const [getConsultationData, consultationData] = useLazyQuery(
    GETCONSULTATION,
    {
      fetchPolicy: "no-cache",
      onCompleted({ getPurchase }) {
        setFromData(getPurchase);
        const { createdAt } = getPurchase;
        setInitialData({
          createdAt: createdAt && moment(createdAt).format("jYYYY/jMM/jDD"),
        });
      },
    }
  );

  const [getMeetingRoomsList, meetingRoomsList] = useLazyQuery(
    GETMEETINGROOMSLIST,
    {
      fetchPolicy: "no-cache",
      onCompleted({ getProducts }) {
        setMeetingRooms(getProducts);
      },
    }
  );

  const [runSetMeetingTime, setMeetingTime] = useMutation(SETMEETINGTIME, {
    onCompleted({ CreateConsultationPurchase }) {
      Modal.success({
        title: "موفق",
        content: "ثبت زمان ملاقات با موفقیت انجام شد.",
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
        onOk: () => {
          setRefetch(refetch + 1, onDataUpdate());
        },
      });
    },
    onError(err) {
      console.log("خطا: " + err.message);

      Modal.error({
        title: "مشکلی پیش آمده!",
        content:
          err?.message === "این بازه از قبل رزرو شده است" ? (
            <>
              <div>{err.message}</div>
              {reservedHours.length !== 0 && (
                <>
                  <div>بازه‌های رزرو شده این اتاق در روز انتخاب شده:</div>
                  {reservedHours.map((reserve, index) => (
                    <div key={index} style={{ color: "red" }}>
                      {reserve.startAt} تا {reserve.endAt}
                    </div>
                  ))}
                </>
              )}
            </>
          ) : (
            err.message
          ),
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
      });
    },
  });

  useEffect(() => {
    if (id) {
      getConsultationData({
        variables: {
          id,
        },
      });
    }
  }, [id, refetch]);

  const { Panel } = Collapse;
  const onStartSetMeetingTime = () => {
    if (!meetingRooms) {
      getMeetingRoomsList({
        variables: {
          paginateInput: {
            page: 1,
            perPage: 100,
          },
          searchInput: {
            category: "MEETING_ROOM",
          },
        },
      });
    }
  };
  const handleMeetingRoomSelect = (value) => {
    setSelectedMeetingRoom(value);
  };

  function range(start, end) {
    const result = [];
    for (let i = start; i < end; i++) {
      result.push(i);
    }
    return result;
  }

  useEffect(() => {
    const disablehours = range(0, 8).concat(range(21, 24));
    reservedHours?.forEach((time) => {
      const start = parseInt(time?.startAt);
      const end = parseInt(time?.endAt);
      for (let i = start; i < end; i++) {
        disablehours.push(i);
      }
    });
    setDisabledStartHours(disablehours);
  }, [reservedHours]);

  const disabledDateTime = () => {
    return {
      disabledHours: () => disabledStartHours,
    };
  };

  const disabledEndTime = () => {
    const disabledHour = startTime?.hour?.();
    const disabledMinute = startTime?.minute?.();
    const reservedDisabled = [...disabledStartHours];
    if (startTime && reservedHours?.length > 0) {
      const startHour = startTime.hour();
      // const startMinute = startTime.minute();
      const blockedRanges = reservedHours.map((t) => ({
        start: parseInt(t.startAt),
        end: parseInt(t.endAt),
      }));
      const nextBlocked = blockedRanges.find((r) => r.start > startHour);
      if (nextBlocked) {
        for (let i = nextBlocked.start + 1; i <= 23; i++) {
          if (!reservedDisabled.includes(i)) reservedDisabled.push(i);
        }
      }
    }
    return {
      disabledHours: () => [...Array(disabledHour).keys(), ...reservedDisabled],
      disabledMinutes: (selectedHour) => {
        if (selectedHour === disabledHour) {
          return [...Array(disabledMinute).keys()];
        }
        return [];
      },
    };
  };

  const onFinishSettingMeetingDate = ({
    meetingDate,
    meetingStartTime,
    meetingEndTime,
    meetingRoom,
    description,
  }) => {
    const startAt = moment(meetingDate)
      .hour(meetingStartTime.hour())
      .minute(meetingStartTime.minute());
    const endAt = moment(meetingDate)
      .hour(meetingEndTime.hour())
      .minute(meetingEndTime.minute());

    if (startAt.isSame(endAt))
      return Modal.error({
        title: "مشکلی پیش آمده!",
        content: "ساعت آغاز و پایان جلسه یکسان هستند!",
        bodyStyle: { direction: "rtl" },
        okText: "باشه",
      });

    runSetMeetingTime({
      variables: {
        createConsultationPurchaseInput: {
          productId: meetingRoom,
          forConsultationId: id,
          startAt,
          endAt,
          description,
        },
      },
    });
  };
  const { createdAt } = initialData;

  if (consultationData.loading)
    return (
      <>
        <Skeleton active round />
        <br />
        <Skeleton active round />
      </>
    );
  return (
    <>
      <Row>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>درخواست کننده: </p>
            {formData?.user?.name}
          </Space>
        </Col>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>تاریخ درخواست: </p>
            {createdAt}
          </Space>
        </Col>
      </Row>
      <Row>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>شماره تماس: </p>
            {formData?.user?.mobile}
          </Space>
        </Col>
        <Col sm={12} xs={24}>
          <Space align="">
            <p>هزینه پرداخت شده:</p>
            {formData?.amount.toLocaleString()} ریال
          </Space>
        </Col>
      </Row>

      <Row>
        <Col xs={24}>
          <Space align="">
            <p>نام محصول (مشاوره):</p>
            {formData?.product?.name}
          </Space>
        </Col>
        <Col xs={24}>
          <Space align="">
            <p>توضیحات:</p>
            {formData?.description}
          </Space>
        </Col>
        {formData?.reserve ? (
          <Col xs={24}>
            <Alert
              message="قرار ملاقات تنظیم شده"
              description={`قرار ملاقات در تاریخ ${moment(
                formData?.reserve.startAt
              ).format("jYYYY/jMM/jDD")} از ساعت ${moment(
                formData?.reserve.startAt
              ).format("HH:mm")} تا ${moment(formData?.reserve.endAt).format(
                "HH:mm"
              )} در مکان ${formData?.reserve?.product?.name} تنظیم شده است.`}
              type="success"
              banner
              style={{ width: "100%", marginBottom: "30px" }}
            />
            {formData?.reserve?.description && (
              <>
                <Space>یادداشت:</Space>
                <Alert
                  type="info"
                  description={formData?.reserve?.description}
                />
              </>
            )}
          </Col>
        ) : (
          <>
            <Collapse
              onChange={onStartSetMeetingTime}
              style={{ width: "100%" }}
            >
              <Panel header="تنظیم قرار مشاوره">
                <Form
                  layout="vertical"
                  onFinish={onFinishSettingMeetingDate}
                  form={form}
                >
                  <Row>
                    <Col sm={12}>
                      {meetingRoomsList.loading ? (
                        <Skeleton active round />
                      ) : meetingRoomsList.data && meetingRooms ? (
                        <Form.Item name="meetingRoom" label="انتخاب اتاق جلسه">
                          <Select
                            defaultValue={{
                              label: "اتاق جلسه",
                              value: null,
                            }}
                            onChange={handleMeetingRoomSelect}
                            style={{
                              width: 160,
                            }}
                            options={meetingRooms.map((mt) => ({
                              label: mt.name,
                              value: mt.id,
                            }))}
                          />
                        </Form.Item>
                      ) : (
                        <Alert
                          message="خطایی در حین دریافت اتاق جلسات رخ داده لطفا دوباره تلاش کنید!"
                          type="error"
                        />
                      )}
                    </Col>
                    <Col sm={12}>
                      {selectedMeetingRoom && (
                        <Form.Item name="meetingDate" label="انتخاب روز جلسه">
                          <DatePicker
                            placeholder={"انتخاب تاریخ"}
                            disabledDate={(current) =>
                              current < moment().startOf("day")
                            }
                            onChange={(date, dateString) =>
                              setSelectedMeetingDate({ date, dateString })
                            }
                          />
                        </Form.Item>
                      )}
                    </Col>
                    {selectedMeetingDate && (
                      <>
                        <Col sm={12}>
                          <Form.Item
                            name="meetingStartTime"
                            label="انتخاب ساعت شروع جلسه"
                          >
                            <TimePicker
                              placeholder={"ساعت شروع"}
                              format={"HH:mm"}
                              showNow={false}
                              minuteStep={30}
                              disabledTime={disabledDateTime}
                              hideDisabledOptions={true}
                              onChange={(value) => {
                                setStartTime(value);
                              }}
                              disabled={
                                selectedMeetingDate &&
                                selectedMeetingDate !== "Invalid date"
                                  ? false
                                  : true
                              }
                            />
                          </Form.Item>
                        </Col>
                        {startTime && (
                          <>
                            <Col sm={12}>
                              <Form.Item
                                name="meetingEndTime"
                                label="انتخاب ساعت پایان جلسه"
                                rules={[
                                  {
                                    required: true,
                                    message:
                                      "لطفا ساعت پایان جلسه را وارد کنید!",
                                  },
                                ]}
                              >
                                <TimePicker
                                  placeholder={"ساعت پایان"}
                                  format={"HH:mm"}
                                  showNow={false}
                                  minuteStep={30}
                                  disabledTime={disabledEndTime}
                                  hideDisabledOptions={true}
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24}>
                              <Form.Item name="description" label="یادداشت">
                                <TextArea placeholder="توضیحات" autoSize />
                              </Form.Item>
                            </Col>
                            <Col xs={24}>
                              <Button type="primary" htmlType="submit">
                                ثبت زمان ملاقات
                              </Button>
                            </Col>
                          </>
                        )}
                      </>
                    )}
                  </Row>
                </Form>
              </Panel>
            </Collapse>
          </>
        )}
      </Row>
    </>
  );
}

export default ConsultationsTableDetails;
